import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a056c6ce&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=a056c6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a056c6ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a056c6ce')) {
      api.createRecord('a056c6ce', component.options)
    } else {
      api.reload('a056c6ce', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a056c6ce&scoped=true&", function () {
      api.rerender('a056c6ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23mcqioj3ftB1/JS/comp/SearchFilterTokens.vue"
export default component.exports